var path = 'app/scripts/modules/amazon/src/pipeline/stages/enableAsg/enableAsgStepLabel.html';
var html = "<span class=\"task-label\">\n  Enable Server Group:\n  {{step.context.serverGroupName}}\n  ({{step.context.region}})\n</span>\n";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./app/scripts/modules/amazon/src/pipeline/stages/enableAsg/enableAsgStepLabel.html
// module id = 1223
// module chunks = 0